import { useRef } from 'react';
import { HiOutlineUserCircle } from 'react-icons/hi2';
import { OverlayPanel } from 'primereact/overlaypanel';
import { Tooltip } from 'primereact/tooltip';
import { useAuth } from '@/context/AuthContext';
import ThemeToggle from './ThemeToggle';

const AccountButton = () => {
  const op = useRef<OverlayPanel>(null);
  const { user, logout, isRetoolMode, isAuthenticated, isLoading } = useAuth();

  // Don't render account button in Retool mode
  if (isRetoolMode) {
    return null;
  }

  const handleLogout = () => {
    logout();
  };

  return (
    <div className='flex items-center w-full justify-center'>
      <Tooltip target='.account-btn' />
      <button
        onClick={(e) => op.current?.toggle(e)}
        className='account-btn p-3 rounded-lg theme-transition 
                   hover:bg-accent hover:text-accent-foreground 
                   focus:outline-none focus:ring-2 focus:ring-primary/20'
        data-pr-tooltip='Account'
      >
        <HiOutlineUserCircle className='w-6 h-6' />
      </button>

      {isAuthenticated && !isLoading && (
        <OverlayPanel
          ref={op}
          appendTo={document.body}
          style={{ margin: '0.5rem 0 0 1rem' }}
        >
          <div className='w-64'>
            <h3 className='text-lg font-bold mb-0'>
              {user?.name || 'Account'}
            </h3>
            <p className='mb-4'>{user?.email || 'No email'}</p>

            <ThemeToggle />

            <button
              onClick={handleLogout}
              className='w-full px-4 py-2 outline cursor-pointer text-red-500 rounded hover:bg-red-500 hover:text-white transition-colors'
            >
              Logout
            </button>
          </div>
        </OverlayPanel>
      )}
    </div>
  );
};

export default AccountButton;
